/** @jsx jsx */
import { tokens } from '@datacamp/waffles/tokens';
import { jsx } from '@emotion/react';
import React, { Suspense } from 'react';

import DCSpinner from '../DCSpinner';
import ErrorBoundary from '../ErrorBoundary';

const monacoImporter = () =>
  import(/* webpackChunkName: "monaco" */ './MonacoCodeEditor');

const MonacoCodeEditor = React.lazy(monacoImporter);

const CodeEditorLoader = (props: any) => {
  return (
    <div
      css={{
        width: '100%',
        height: '100%',
        ...(props.uiTheme === 'DARK' && {
          backgroundColor: tokens.colors.navy,
        }),
      }}
    >
      <ErrorBoundary>
        <Suspense fallback={<DCSpinner uiTheme={props.uiTheme} />}>
          <MonacoCodeEditor {...props} key={props.id} />
        </Suspense>
      </ErrorBoundary>
    </div>
  );
};

export default CodeEditorLoader;
